var App = App || {};

App.Forms = (function ($) {
    "use strict";

    var umbracoForms = $(".umbraco-forms-page");
    var miscForms = $("form.needs-validation")

    function init() {
        var firstForm = true;

        umbracoForms.each(function () {
            var parentForm = $(this);

            waitForElement('#umbraco-forms-form-submitted', () => {

                if (firstForm) {
                    var invalidFields = parentForm.find(".field-validation-error");
                    if (invalidFields.length) {
                        var firstError = invalidFields.first().parents(".umbraco-forms-field-wrapper").find("input, select, textarea").first();
                        focusAndScrollTo(firstError);
                        firstForm = false;
                    }
                }
            });
        });

        miscForms.each(function () {
            var thisForm = $(this);
            var submitButton = thisForm.find("button[type='submit']");
            if (!submitButton.length) {
                submitButton = thisForm.find("button");
            }

            submitButton.on('click', function () {
                var invalidFields = thisForm.find("input:invalid, select:invalid, textarea:invalid");
                if (invalidFields.length) {
                    focusAndScrollTo(invalidFields.first());
                }
            });
        });
    }

    function waitForElement(selector, callback) {
        const observer = new MutationObserver((mutations) => {
            if ($(selector).length) {
                observer.disconnect();
                callback();
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    function focusAndScrollTo(firstError) {
        firstError.trigger("focus");

        $('html, body').animate({
            scrollTop: firstError.offset().top
        }, 10);
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Forms.init();
});